/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rodapeMapa[_ngcontent-%COMP%]{background-color:#fff;height:50px;position:relative;width:100%;top:-55px}\n/*# sourceMappingURL=posicao-billing.component.css.map*/"];
export { styles as styles };
